module.exports = __webpack_public_path__ + "img/ewallet1.51972d54.png";